// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, push, onValue, remove, update, get } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBxLHNlgwmXuLub78zc57yppKmNQtX5EHQ",
  authDomain: "kohla-news.firebaseapp.com",
  projectId: "kohla-news",
  storageBucket: "kohla-news.firebasestorage.app",
  messagingSenderId: "363901268689",
  appId: "1:363901268689:web:670822c51cec8e14f48bf0",
  measurementId: "G-C5P0E6K7MF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage(app);

// ========== ARTICLES FUNCTIONS ==========

// Get all articles
export const getArticles = () => {
  return new Promise((resolve, reject) => {
    const articlesRef = ref(database, 'articles');
    onValue(articlesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const articles = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        // Sort by date (newest first)
        articles.sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));
        resolve(articles);
      } else {
        resolve([]);
      }
    }, (error) => {
      reject(error);
    });
  });
};

// Get single article by ID
export const getArticleById = (id) => {
  return new Promise((resolve, reject) => {
    const articleRef = ref(database, `articles/${id}`);
    onValue(articleRef, (snapshot) => {
      const data = snapshot.val();
      resolve(data ? { id, ...data } : null);
    }, (error) => {
      reject(error);
    });
  });
};

// Add new article
export const addArticle = (article) => {
  const articlesRef = ref(database, 'articles');
  const newRef = push(articlesRef);
  return set(newRef, {
    ...article,
    publishedDate: new Date().toISOString(),
    views: 0
  });
};

// Update article
export const updateArticle = (id, article) => {
  const articleRef = ref(database, `articles/${id}`);
  return update(articleRef, {
    ...article,
    updatedDate: new Date().toISOString()
  });
};

// Delete article
export const deleteArticle = (id) => {
  const articleRef = ref(database, `articles/${id}`);
  return remove(articleRef);
};

// ========== IMAGE UPLOAD FUNCTIONS ==========

// Upload image
export const uploadImage = async (file, folder = 'articles') => {
  const fileName = `${Date.now()}_${file.name}`;
  const imageRef = storageRef(storage, `${folder}/${fileName}`);
  
  try {
    const snapshot = await uploadBytes(imageRef, file);
    const url = await getDownloadURL(snapshot.ref);
    return {
      url,
      path: snapshot.ref.fullPath,
      name: fileName
    };
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

// Delete image
export const deleteImage = async (path) => {
  const imageRef = storageRef(storage, path);
  try {
    await deleteObject(imageRef);
    return true;
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error;
  }
};

export default database;